/**
 * Date-disjoint merge for the ticker flow ownership split (spec §11.3, Phase 4 /
 * D3). The DO owns the current session (today); Hasura's 28-day history owns
 * every date before it. Because the two sources are disjoint by trading date,
 * the merge needs no dedupe and has no race window.
 *
 *   rendered = live(today) ++ history(date < sessionDate)
 *
 * Both sides normalize `date` to YYYY-MM-DD so a full-timestamp history value
 * compares correctly against the plain session date.
 */

interface DatedRow {
  date?: unknown;
}

function normDate(d: unknown): string {
  return String(d ?? '').slice(0, 10);
}

export function mergeLiveHistory<T extends DatedRow>(
  live: T[],
  history: T[],
  sessionDate: string | null,
): T[] {
  // DO not ready yet — render history alone so there's no empty flash.
  if (!sessionDate) return history;
  const liveToday = live.filter((r) => normDate(r.date) === sessionDate);
  const historyPrior = history.filter((r) => normDate(r.date) < sessionDate);
  return [...liveToday, ...historyPrior];
}
